var map = {
	"./add-white.svg": "47bb",
	"./business-finance-white.svg": "f054",
	"./car-wash-white.svg": "c075",
	"./pencil-white.svg": "332f",
	"./protection-white.svg": "f868",
	"./tools-white.svg": "0572",
	"./wash-white.svg": "4c36",
	"./wheel-white.svg": "4936",
	"./windscreen-air-white.svg": "c6ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e483";